module.exports = __webpack_public_path__ + "img/chat-right-dots.29ffd25d.svg";